import React from 'react';

const FailureIcon: React.FC = () => {
	return (
		<div className="logout-icon m-auto">
			<svg enableBackground="new 0 0 161.2 161.2" version="1.1" viewBox="0 0 161.2 161.2" xmlSpace="preserve" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
				<circle cx="80.6" cy="80.6" r="62.1" fill="none" stroke="#f66" strokeMiterlimit="10" strokeWidth="4" className="path"/>
				<circle cx="80.6" cy="80.6" r="73.9" fill="none" stroke="#ff6969" strokeDasharray="12.2175,12.2175" strokeMiterlimit="10" strokeWidth="4" className="spin"/>
				<g fill="none" stroke="#ff6969" strokeLinecap="round" strokeMiterlimit="10">
					<path d="m81.532 48.598-0.02434 53.657" strokeWidth="6.1103"/>
					<path d="m81.744 114.77-0.02434 0.9935" strokeWidth="5.2709"/>
				</g>
			</svg>
		</div> 
	);
}

export default FailureIcon;